<template>
  <div class="admin-dashboard-page">
    <span v-if="roleAdmin !== 'government' && roleAdmin !== 'markter'">
      <template v-if="roleAdmin !== 'engineer-allocation' && roleAdmin !== 'engineer'">
        <!-- Dashboard Header -->
        <div class="dashboard-header">
          <div class="header-content">
            <div class="header-left">
              <div class="header-icon-wrapper">
                <feather-icon
                  icon="PieChartIcon"
                  size="28"
                />
              </div>
              <div class="header-text">
                <h1 class="page-title">
                  Analytics Dashboard
                </h1>
                <p class="page-subtitle">
                  Branch performance & engineer analytics
                </p>
              </div>
            </div>
            <div class="header-right">
              <feather-icon
                icon="BarChart2Icon"
                size="24"
                class="header-accent-icon"
              />
            </div>
          </div>
        </div>

        <div class="dashboard-layout">
          <div class="branches-sidebar">
            <OurBranches
              ref="branches"
              class="branches-fill"
              :role-admin="roleAdmin"
              @dataChartToTable="dataChartEmit"
              @loadingChart="getLoading"
              @loadingDataUser="getLoadingDataUser"
              @userData="getUserData"
            />
          </div>
          <div class="chart-content">
            <div
              v-if="isLoading"
              class="loading-wrapper chart-fill"
            >
              <div class="loading-spinner">
                <b-spinner
                  variant="primary"
                  type="grow"
                  label="Spinning"
                />
              </div>
              <span class="loading-text">Loading analytics...</span>
            </div>
            <IndexChartBar
              v-else
              class="chart-fill"
              :data-chart="dataChart"
              :user-data="userData"
              :user-loading="isUserLoading"
              :chart-loading="isChartLoading"
              @need-user-data="ensureUserDataLoaded"
            />
          </div>
        </div>
      </template>
    </span>
  </div>
</template>

<script>
import OurBranches from './our-branches/OurBranches.vue'
import IndexChartBar from './components/chart-bar-engineer/IndexChartBar.vue'

export default {
  components: {
    OurBranches,
    IndexChartBar,
  },
  data() {
    return {
      dataChart: {},
      userData: [],
      isLoading: false,
      isUserLoading: false,
      isChartLoading: false,
      roleAdmin: localStorage.getItem('user_role'),
    }
  },
  methods: {
    dataChartEmit(getChartData) {
      this.dataChart = getChartData
    },
    getLoading(getLoading) {
      this.isChartLoading = getLoading
    },
    getLoadingDataUser(getLoading) {
      this.isUserLoading = getLoading
    },
    getUserData(data) {
      if (Array.isArray(data)) {
        this.userData = data
      }
    },
    ensureUserDataLoaded(userId) {
      if (this.$refs.branches && typeof this.$refs.branches.getUserData === 'function') {
        this.$refs.branches.getUserData(userId)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.admin-dashboard-page {
  padding: 0.5rem 0;
}

.dashboard-header {
  background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
  border-radius: 12px;
  padding: 1.5rem 1.75rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 20px rgba(115, 103, 240, 0.35);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.header-icon-wrapper {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  backdrop-filter: blur(4px);
}

.header-text {
  .page-title {
    color: white;
    font-size: 1.5rem;
    font-weight: 700;
    margin: 0 0 0.25rem 0;
    letter-spacing: -0.02em;
  }

  .page-subtitle {
    color: rgba(255, 255, 255, 0.9);
    font-size: 0.9rem;
    margin: 0;
    font-weight: 500;
  }
}

.header-right .header-accent-icon {
  color: rgba(255, 255, 255, 0.6);
}

.dashboard-layout {
  display: grid;
  grid-template-columns: 340px 1fr;
  gap: 1.5rem;
  min-height: calc(80vh - 2rem);

  @media (max-width: 991px) {
    grid-template-columns: 1fr;
    min-height: auto;
  }
}

.branches-sidebar {
  min-width: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.chart-content {
  min-width: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.branches-fill,
.chart-fill {
  flex: 1;
  min-height: 0;
}

.loading-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #ebe9f1;
  box-shadow: 0 2px 8px rgba(34, 41, 47, 0.06);
}

.loading-spinner {
  margin-bottom: 1rem;
}

.loading-text {
  font-size: 0.95rem;
  color: #b9b9c3;
  font-weight: 500;
}
</style>
